import { createSelector } from "reselect";

import { workspaceEntityAdapter, workspaceSlice } from "./slice";

const selectWorkspaceState = (state) => state[workspaceSlice.name];

export const selectWorkspaceEntities = createSelector(selectWorkspaceState, (workspaceState) => {
  return workspaceEntityAdapter.getSelectors().selectEntities(workspaceState);
});

export const selectWorkspaces = createSelector(selectWorkspaceState, (workspaceState) => {
  return workspaceEntityAdapter.getSelectors().selectAll(workspaceState);
});

export const selectWorkspaceDetailsByEntityId = createSelector(
  selectWorkspaceState,
  (state, props) => props.entityId,
  (workspaceState, workspaceId) =>
    workspaceEntityAdapter.getSelectors().selectById(workspaceState, workspaceId) || null,
);

export const selectAllWorkspaceDetails = createSelector(selectWorkspaceState, (workspaceState) => {
  return workspaceState.workspacesDetails;
});

export const selectOrganizationWorkspacesCount = createSelector(
  selectWorkspaceState,
  (workspaceState) => workspaceState.totalOrganizationWorkspaces,
);

export const selectSelectedWorkspaceDetails = createSelector(selectWorkspaceEntities, (workspaceObject) => {
  return Object.keys(workspaceObject).map((key) => {
    const item = workspaceObject[key];

    return item;
  });
});

export const selectSelectedWorkspaceTotalUsers = createSelector(
  selectWorkspaceDetailsByEntityId,
  (workspaceState) => workspaceState?.totalUsers || 0,
);

export const selectWorkspacesByOrganizationId = createSelector(selectWorkspaceState, (workspaceState) => {
  return Object.keys(workspaceState.workspacesByOrganizationId).map((key) => {
    const item = workspaceState.workspacesByOrganizationId[key];

    return item;
  });
});

export const selectFilteredWorkspaces = createSelector(selectWorkspaceState, (workspaceState) => {
  return workspaceState.filteredWorkspaces || [];
});

export const selectTotalFilteredWorkspaces = createSelector(selectWorkspaceState, (workspaceState) => {
  return workspaceState.totalFilteredWorkspaces || 0;
});
